import React from 'react';
import Marquee from 'react-fast-marquee';
import AchievementSlide from './AchievementSlide';
import { ACHIEVEMENTS } from '../utils/constants';

export default function AchievementsSection() {
  return (
    <section className="w-full py-8 md:py-12 bg-white">
      <div className="">
        <Marquee
          gradient={false}
          speed={120}
          pauseOnHover={false}
          className="flex items-end gap-0"
        >
          {ACHIEVEMENTS.map((item, idx) => (
            <div key={item.id + '-' + idx} className="mx-2 flex items-end h-full min-w-[200px] max-w-[240px] sm:max-w-[260px] md:min-w-[280px] md:max-w-[260px] lg:max-w-[400px]">
              <AchievementSlide
                image={item.image}
                text={item.text}
                badgePosition={item.badgePosition}
                imageHeight={item.imageHeight}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
} 